import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, input } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { Capacitor } from '@capacitor/core';
import { DndDropEvent, DropEffect } from 'ngx-drag-drop';
import { CodaltComponent } from '../../codalt.component';
import { CustomerProjectPhaseActivity } from '../../customer-project-phase-activity.interface';
import { CustomerProjectPhaseReply } from '../../customer-project-phase-reply.interface';
import { CustomerProjectPhase } from '../../customer-project-phase.interface';
import { AuthorisationService } from '../../services/auth/authorisation.service';
import { Functionalities } from '../../services/auth/functionalities';
import { CustomerProjectPhaseActivityService } from '../../services/customer-project/customer-project-phase-activity.service';
import { CustomerProjectPhaseActivityEditDialogComponent } from './customer-project-phase-activity-edit-dialog/customer-project-phase-activity-edit-dialog.component';

@Component({
    selector: 'app-customer-project-phase-activities',
    templateUrl: './customer-project-phase-activities.component.html',
    styleUrls: ['./customer-project-phase-activities.component.scss'],
    standalone: false,
})
export class CustomerProjectPhaseActivitiesComponent extends CodaltComponent implements OnInit, OnChanges {
    @Input()
    phase: CustomerProjectPhase;

    @Input()
    projectReplies: CustomerProjectPhaseReply[];

    @Input()
    activities: CustomerProjectPhaseActivity[];

    activitiesView: CustomerProjectPhaseActivity[];

    @Input()
    selectedActivity: CustomerProjectPhaseActivity;

    showDoneActivities = input(false);

    @Output()
    activitySelected = new EventEmitter<CustomerProjectPhaseActivity>();

    @Output()
    replyDropped = new EventEmitter<CustomerProjectPhaseReply>();

    disableDragDrop = Capacitor.isNativePlatform();

    constructor(
        private dialog: MatDialog,
        private customerProjectPhaseActivityService: CustomerProjectPhaseActivityService
    ) {
        super();
        if (AuthorisationService.hasFunctionality(Functionalities.GeoRead)) {
            this.disableDragDrop = true;
        }
    }

    onDragged(item: any, list: any[], effect: DropEffect) {
        if (effect === 'move') {
            const index = list.indexOf(item);
            list.splice(index, 1);
        }
        this.customerProjectPhaseActivityService.saveOrder(this.activities).subscribe();
    }

    onDrop(event: DndDropEvent, list?: any[]) {
        if (list && (event.dropEffect === 'copy' || event.dropEffect === 'move')) {
            let index = event.index;
            if (typeof index === 'undefined') {
                index = list.length;
            }

            list.splice(index, 0, event.data);
        }
    }

    selectActivity(activity: CustomerProjectPhaseActivity) {
        this.selectedActivity = activity;
        this.activitySelected.emit(activity);
    }

    drop(event, activity: CustomerProjectPhaseActivity) {
        const reply = event.item.data as CustomerProjectPhaseReply;
        reply.customer_projectphase_activity_id = activity.id;
        this.replyDropped.emit(reply);
    }

    ngOnInit(): void {
        this.initView();
    }

    execute(event: MatCheckboxChange, activity: CustomerProjectPhaseActivity) {
        activity.executed = event.checked ? new Date() : null;
        this.customerProjectPhaseActivityService
            .save(activity)
            .subscribe(result => Object.assign(activity, result.data));
    }

    edit(phaseActivity?: CustomerProjectPhaseActivity) {
        if (!phaseActivity) {
            phaseActivity = {
                customer_projectphase_id: this.phase.id,
            } as CustomerProjectPhaseActivity;
            if (this.activities?.length > 0) {
                phaseActivity.order = this.activities.length + 1;
            } else {
                phaseActivity.order = 1;
            }
        }
        this.dialog
            .open(CustomerProjectPhaseActivityEditDialogComponent, {
                panelClass: 'confirm-dialog',
                disableClose: true,
                data: phaseActivity,
            })
            .afterClosed()
            .subscribe((phase: CustomerProjectPhaseActivity) => {
                if (!phase.deleted_at) {
                    if (!this.activities?.find(p => p.id === phase.id) && phase) {
                        this.activities.push(phase);
                        this.initView();
                    }
                } else {
                    this.activities.splice(this.activities.indexOf(phase), 1);
                    this.initView();
                }
            });
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.initView();
    }

    private initView() {
        if (this.activities) {
            const activities = this.activities.sort((a, b) => {
                if (a.order > b.order) {
                    return 1;
                }
                if (a.order < b.order) {
                    return -1;
                }
                return 0;
            });
            this.activitiesView = activities;
        }
    }
}
